import {Component, OnInit} from '@angular/core';
import {LocalStorageService, UserService} from '../_services';
import {Router} from '@angular/router';

@Component({
  selector: 'app-rippler-wild-card',
  template: '',
  styles: []
})
export class HandleWildCardComponent implements OnInit {
  currentUrl = '';

  constructor(private userService: UserService,
              private localStorage: LocalStorageService,
              private router: Router) {
    const tempUrl: string = this.router.url;
    this.currentUrl = tempUrl.substr(1, this.router.url.length);
  }

  ngOnInit(): void {
    this.getProjectData();
  }

  getProjectData() {
    this.userService.getProjectData()
      .subscribe({
        next: (value) => {
          const projectList: any[] = value;
          console.log(this.currentUrl.replace('-', ' '));
          const ifFound: any = projectList.find((obj: any) => obj.name.toLowerCase() === this.currentUrl.replace('-', ' '));
          console.log(ifFound);
          this.localStorage.set('selected_project', ifFound);
          this.localStorage.set('projectType', ifFound.ref);
          if (ifFound) {
            this.router.navigate(['/map'], {queryParams: {projectType: ifFound.ref}});
          }
          // this.projectList = value;
          // this.selectedProjectObj = value[0];
        },
        error: (err) => {
          console.error(err, 'error');
        }
      });
  }

}
